/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ResponseApiPageUserOperationLog } from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class YongHuCaoZuoRiZhi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags YongHuCaoZuoRiZhi
   * @name PageUsingGet
   * @summary 分页查询用户操作日志
   * @request GET:/dsp-admin/api/logs/page
   * @secure
   */
  pageUsingGet = (
    query?: {
      /** 结束时间 */
      endTime?: string;
      /** 操作描述 */
      operation?: string;
      /** 操作模块 */
      operationModule?: string;
      /** 操作类型 */
      operationType?: string;
      /**
       * 页码
       * @format int32
       */
      pageNum?: number;
      /**
       * 每页数量
       * @format int32
       */
      pageSize?: number;
      /** 开始时间 */
      startTime?: string;
      /** 用户名 */
      username?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPageUserOperationLog, void>({
      path: `/dsp-admin/api/logs/page`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new YongHuCaoZuoRiZhi();
